import styled from 'styled-components';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from 'react-super-responsive-table';

// z-index must stay below the UDS Tooltip's portal (z-index: 100000, appended
// directly to <body> outside this modal's own stacking context) — otherwise
// the backdrop renders on top of any tooltip opened from inside the modal,
// hiding its content behind the dark overlay even though it is technically
// "visible".
export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 1rem;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 4px;
  width: 100%;
  max-width: 960px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  outline: none;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #4b286d;
  color: #ffffff;
  padding: 1rem 1.5rem;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: 1px solid #ffffff;
  color: #ffffff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  overflow: auto;
  flex: 1 1 auto;
  min-height: 0;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e3e3e3;
  flex-shrink: 0;
`;

export const TableBlock = styled.div`
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

// Summary table rendered below the IoTPopupButton, listing every completed
// product. Uses react-super-responsive-table so it collapses cleanly on small
// viewports (Constitution §8).

export const SummaryWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 1rem;
`;

export const SummaryHeading = styled.h3`
  margin: 0 0 0.5rem;
  font-size: 16px;
  font-weight: 700;
  color: #4b286d;
`;

export const ButtonWrapper = styled.div`
  margin: 0.75rem 0 1rem;
`;

export const SummaryGroupHeading = styled.h4`
  margin: 0 0 0.5rem;
  font-size: 14px;
  font-weight: 700;
  color: #4b286d;
`;

export const EmptyHint = styled.p`
  margin: 0;
  font-size: 13px;
  color: #565656;
`;

export const SummaryTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;
`;

export const SummaryThead = styled(Thead)`
  background: #4b286d;
`;

export const SummaryTbody = styled(Tbody)``;

export const SummaryTr = styled(Tr)`
  border: 1px solid #e3e3e3;
`;

export const SummaryTh = styled(Th)`
  text-align: left;
  background: #4b286d;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  padding: 0.5rem;
  border: 1px solid #e3e3e3;
`;

export const SummaryTd = styled(Td)`
  border: 1px solid #e3e3e3;
  text-align: left;
  font-size: 13px;
  color: #565656;
  padding: 0.5rem;
`;

export const SummaryTotalTr = styled(Tr)`
  background: #f4f4f4;
  border: 1px solid #e3e3e3;
`;

export const SummaryTotalTd = styled(Td)`
  border: 1px solid #e3e3e3;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  color: #2b2b2b;
  padding: 0.5rem;
`;

export const RemoveButton = styled.button`
  background: transparent;
  border: 1px solid #c12335;
  color: #c12335;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 12px;
  cursor: pointer;

  &:hover,
  &:focus {
    background: #c12335;
    color: #ffffff;
  }
`;
